import {Component, ElementRef, Input, OnChanges} from '@angular/core';
import {ContextMenuItem} from '../../types/context-menu-item';
import {Submenu} from '../../types/submenu';
import {ContextMenuEntry} from '../../types/context-menu-entry';

@Component({
  selector: 'ctx-submenu',
  template: `<li class="context-list-item">
  <div class="flex-container">
    <span class="context">{{item.text}}</span>
    <span style="flex: 1 1 auto;"></span>
    <span class="shortcut">>>></span>
  </div>
  <ul class="context-list submenu menu" [ngStyle]="subMenuStyle">
    <ng-container *ngFor="let subItem of item.children">
      <ctx-context-menu-item *ngIf="isAction(subItem)" [item]="subItem"></ctx-context-menu-item>
      <ctx-submenu *ngIf="!isAction(subItem)" [item]="subItem"></ctx-submenu>
    </ng-container>
  </ul>
</li>
`,
  styles: [``]
})
export class SubmenuComponent implements OnChanges {

  @Input() item: Submenu;

  constructor(private element: ElementRef) { }

  public subMenuStyle = {};

  public ngOnChanges(): void {
    const rect = this.element.nativeElement.getBoundingClientRect();
    this.subMenuStyle = {
      'left': 214 + 'px',
      'top': rect.offsetHeight + 'px'
    };
  }

  /**
   * Check if this is an action
   * @param item
   * @returns
   */
  public isAction(item: ContextMenuEntry): boolean {
    return !!(item as ContextMenuItem).action;
  }
}
